export function useCspNonce(): string | undefined {
  const cspNonce = useState<string | undefined>('csp-nonce', () => {
    if (import.meta.server) {
      return useRequestEvent()?.context.cspNonce
    }

    const nonceScript = document.querySelector('script[nonce]')
    return nonceScript?.getAttribute('nonce') ?? undefined
  })

  return cspNonce.value
}
